var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.packages && _vm.packages.length)?_c('t-grid',{attrs:{"items":_vm.packages,"idKey":"licencePlate","columnDefinitions":_vm.columnDefinitions,"rowHeight":30,"showFilters":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }